import React, { useRef, useCallback } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { Link, useHistory } from 'react-router-dom';
import { FiAtSign } from 'react-icons/fi';
import { IoIosArrowBack } from 'react-icons/io';
import * as Yup from 'yup';

import { useToast } from '../../hooks/toast';

import api from '../../services/api';

import Input from '../../components/Input';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';

import logo from '../../assets/logo.svg';

import { Container, AnimationContainer, Background } from './styles';

interface ForgotPasswordRequest {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const history = useHistory();

  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: ForgotPasswordRequest) => {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape<ForgotPasswordRequest>({
        email: Yup.string()
          .email('Informe um e-mail válido.')
          .required('Informe seu e-mail.'),
      });

      try {
        await schema.validate(data, { abortEarly: false });

        await api.patch('/password/reset', data);

        addToast({
          type: 'success',
          title: 'E-mail enviado com sucesso',
          description: 'Cheque seu e-mail para ter acesso a sua nova senha.',
        });

        history.push('/');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao recuperar a senha',
          description:
            err.response?.data.message ||
            'Ocorreu um erro ao ao recuperar a senha. Tente novamente.',
        });
      }
    },
    [addToast],
  );

  return (
    <>
      <Container>
        <AnimationContainer>
          <div>
            <img src={logo} alt="Atac Sistemas" style={{ width: 180 }} />
            <span>
              Insira seu e-mail abaixo para receber
              <br />a sua nova senha
            </span>
          </div>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input
              name="email"
              type="email"
              icon={FiAtSign}
              placeholder="E-mail"
            />
            <Button type="submit">Recuperar senha</Button>
            <Link to="/">
              <IoIosArrowBack size={16} />
              Voltar para o login
            </Link>
          </Form>
          <aside>
            <p>
              Desenvolvido por <strong>Atac Sistemas</strong>
              <span>Todos os direitos reservados</span>
            </p>
          </aside>
        </AnimationContainer>
      </Container>
      <Background />
    </>
  );
};

export default ForgotPassword;
